/**
 * Shared email-format rule for the auth forms.
 *
 * Register and Forgot-password each carried their own identical copy of this
 * pattern, and Login had none at all — which is why Login was the one form still
 * falling back to the browser's native validation bubble.
 */
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const isValidEmail = (value) => (
    typeof value === "string" && EMAIL_PATTERN.test(value.trim())
);
